/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetFeaturedMusicRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'
import {GetFeaturedMusicResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/music.pb'


export const getFeaturedMusic = (request: GetFeaturedMusicRequest, options?: CashRequestOptions) => post<GetFeaturedMusicRequest, GetFeaturedMusicResponse>("/2.0/cash/get-featured-music", request, {...options, rejectOnError: true })